import {appConfig} from '@stencil/hotels-config';
import parseDateIntoHermesString from './date-utils/parse-date-into-hermes-string';
import getLocusUrlString from './get-locus-url-string';
import {getAppliedFiltersUniFormatString} from './common-utils';

const {defaultPartner} = appConfig;

const getDetailsPageUrl = (
  {
    hotelData = {},
    partner = defaultPartner,
    checkin,
    checkout,
    country = '',
    roomString,
    staticData = {},
    destination = {},
    locus = {},
    filter = {},
    metaPartner = '',
    offerCode = '',
    appliedFilters = [],
    cityId = '',
    srpContinuedFilters = {},
    appliedFiltersUniFormat = [],
    newFilterData,
    newLocationData,
    sort,
    selectedRatePlanIndex,
    isSrpAltAcco = false,
    topHtlId = '',
    funnelSouce,
    unifSrpFilterData,
    scrollToId = '',
    fcSlotId = '',
    sType = '',
  },
  isDayUse = false,
) => {
  const {ct = {}, xtr = {}, n: destinationCityName, t = ''} = destination;

  let cityName = ct?.n || destinationCityName;
  if (t === 'hotel' && staticData && Object.keys(staticData).length > 0) {
    cityName = staticData?.c;
  }

  const {cc = ''} = xtr;

  if (xtr && xtr.flt) {
    const {n: voyCityName = ''} = ct;
    cityName = voyCityName;
  }

  const {date: checkinDate} = checkin;
  const {date: checkoutDate} = checkout;
  let hmd = '',
    reviewtype = '';
  const {hn, hc, ibp = '', vnd = '', mmtId} = hotelData;
  if (hotelData.hmd) hmd = hotelData.hmd;

  const hName = hn.replace(/\//g, ' ').toLowerCase();
  let urlHname = hName.replace(/[^\w\s]/gi, '').split(' ');
  urlHname = urlHname.filter(el => {
    if (el !== '' && el !== 'hotel') {
      return true;
    }
  });

  urlHname = urlHname.join('-');
  if (hotelData.gri) reviewtype = hotelData.gri === 3 ? 'ta' : 'gi';
  const {hctx = '', sctx = []} = filter;
  const hotelContext = hctx ? `&hctx=${hctx}` : '';
  const subContext = sctx && sctx.length ? `&sctx=${sctx}` : '';
  const isMeta = metaPartner ? `&metaTraffic=${metaPartner}` : '';
  const isHmd = hmd ? `&hmd=${hmd}` : '';
  const isOfferCode = offerCode ? `&offerCode=${offerCode}` : '';
  const reviewType = reviewtype ? `&reviewType=${reviewtype}` : '';
  const vcid = cityId ? `&vcid=${cityId}` : '';
  const srpFilters = Object.keys(srpContinuedFilters)?.length
    ? `&srpFilters=${encodeURIComponent(JSON.stringify(srpContinuedFilters))}`
    : '';

  const hotelQueryString = JSON.stringify({
    ci: parseDateIntoHermesString(checkinDate),
    co: parseDateIntoHermesString(checkoutDate),
    r: roomString,
    ibp,
  });

  const urlCityName = cityName?.replace(/\//g, '').toLowerCase();

  const isVendor = vnd ? `&vnd=${vnd}` : '';
  const appliedFiltersQueryParam =
    appliedFilters.length > 0 ? `&appliedFilters=${JSON.stringify(appliedFilters)}` : '';

  const type = isDayUse ? 'hotel-hourly' : 'hotel';

  // TO:DO: fdwp param
  const filterData = (!!newFilterData && `&filterData=${newFilterData}`) || '';
  const locationData = (!!newLocationData && `&locationData=${newLocationData}`) || '';
  const unifFilter = (!!unifSrpFilterData && `&unifFilterData=${unifSrpFilterData}`) || '';

  const sortApplied = !!sort ? `&sort=${sort}` : '';
  const ccQ = (country && `&cc=${country}`) || '';
  const locusUrlStr = getLocusUrlString(locus);
  const appliedFiltersUniFormatStr = getAppliedFiltersUniFormatString(appliedFiltersUniFormat);
  const arpi = (selectedRatePlanIndex && `&selectedRatePlanIndex=${selectedRatePlanIndex}`) || '';
  const isSrpAltAccoStr = (isSrpAltAcco && `&altAcco=${isSrpAltAcco}`) || '';
  const topHtlIdValue = topHtlId ? `&topHtlId=${topHtlId}` : '';
  const sTypeValue = sType ? `&sType=${sType}` : '';
  const ismmtId = mmtId ? `&mmtId=${mmtId}` : '';
  const isfunnelSouce = funnelSouce ? `&FS=${funnelSouce}` : '';
  const isScrollToId = scrollToId ? `${scrollToId}` : '';
  const city = cityName ? `&city=${cityName}` : '';
  const flexibleCheckinSlotId = fcSlotId ? `&fcSlotId=${fcSlotId}` : '';

  let url = `/${partner}/${urlHname}-${type}-in-${urlCityName}-${hc}/?hquery=${hotelQueryString}${hotelContext}${subContext}${isMeta}${isOfferCode}${isHmd}${ccQ}${appliedFiltersQueryParam}${reviewType}${isVendor}${vcid}${srpFilters}${locusUrlStr}${appliedFiltersUniFormatStr}${filterData}${locationData}${sortApplied}${arpi}${ismmtId}${topHtlIdValue}${isfunnelSouce}${isSrpAltAccoStr}${city}${unifFilter}${flexibleCheckinSlotId}${sTypeValue}`;
  url += isScrollToId; // This is added separately in end since it's a string with # in it. Eg: #location
  return url;
};

/* This is the get the Detail page Root Url(without checkin checkout , pax, filters or any other query params) for the selected hotel
   This is currently used for creating anchor link for the SEO SRP segment sliders, details page Similar Hotels
*/
export const getDetailsPageHotelRootUrl = ({
  hotelData = {},
  partner = defaultPartner,
  staticData = {},
  destination = {},
  checkin = null,
  checkout = null,
  roomString = '',
  appendHquery = false,
}) => {
  const {ct = {}, xtr = {}, n: destinationCityName, t = ''} = destination;

  let cityName = ct?.n || destinationCityName;
  if (t === 'hotel' && staticData && Object.keys(staticData).length > 0) {
    cityName = staticData?.c;
  }

  if (xtr && xtr.flt) {
    const {n: voyCityName = ''} = ct;
    cityName = voyCityName;
  }
  const {hn, hc} = hotelData;

  const hName = hn.replace(/\//g, ' ').toLowerCase();
  let urlHname = hName.replace(/[^\w\s]/gi, '').split(' ');
  urlHname = urlHname.filter(el => {
    if (el !== '' && el !== 'hotel') {
      return true;
    }
  });

  urlHname = urlHname.join('-');

  const urlCityName = cityName?.replace(/\s+/g, '-')?.replace(/\//g, '')?.toLowerCase();
  const baseUrl = `/${partner}/${urlHname}-hotel-in-${urlCityName}-${hc}/`;

  // forming hqyeryObject
  // format for object hquery={"ci":"20210801","co":"20210805","r":"1-2-0","ibp":"v15"}
  const hQueryObject = {};
  if (checkin?.date && checkout?.date) {
    hQueryObject['ci'] = parseDateIntoHermesString(checkin.date);
    hQueryObject['co'] = parseDateIntoHermesString(checkout.date);
  }
  if (roomString && roomString.trim().length > 0) {
    hQueryObject['r'] = roomString;
  }

  let detailsPageUrl = baseUrl;
  if (hQueryObject && Object.keys(hQueryObject).length > 0 && appendHquery) {
    detailsPageUrl += `?hquery=${JSON.stringify(hQueryObject)}`;
  }
  return detailsPageUrl;
};

export default getDetailsPageUrl;
